export default __webpack_public_path__ + "static/media/facebook-live-btn.d9ee1be4.png";